<div class="gtp-chart card mb-2">
    <div class="card-body">
        <span>{{label}}</span>
        <div><span class="h4 fw-bold">{{amount}} </span> <span class="text-muted">{{subLabel}}</span></div>
    </div>
    <apx-chart
      [series]="chartOptions.series"
      [chart]="chartOptions.chart"
      [xaxis]="chartOptions.xaxis"
      [yaxis]="chartOptions.yaxis"
      [stroke]="chartOptions.stroke"
      [tooltip]="chartOptions.tooltip"
      [dataLabels]="chartOptions.dataLabels"
    ></apx-chart>
  </div>